import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { ScreenLayout } from '@/components/ScreenLayout';
import HistorySection from './sections/HistorySection';
import SummarySection from './sections/SummarySection';
export default function ReviewScreen() {
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [_jsx(SummarySection, {}), _jsx(HistorySection, {})] }));
}
